import React,{useState,useEffect} from 'react';
import TestimonialItem from "../../../Items/TestimonialItem";
import noImage from "../../../../assets/image/male-placeholder-image.jpeg"
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "animate.css";

import { postData } from '../../../../services/api';
import { useTranslation } from "react-i18next";

const ClientTestimonials = () => {
  const { i18n,t } = useTranslation();
  const [testimonials,setTestimonials] = useState([]);

  useEffect(() => {
    const loadList = async () => {
      const result = await postData("/testimonial/list", {
        sortQuery: {created_at:1},
        status : 1,
      });
      if (result.data) {
        setTestimonials(
          result.data.map((item,index)=>{
            return {
              name : item?.name?.[i18n?.language],
              designation : item?.company?.[i18n?.language],
              image : noImage,
              description : item?.comments?.[i18n?.language],
            }
          })
        );
      }
    };
    loadList();
  }, [i18n?.language]);

  const TestimonialData = {
    title:t('What_do_our_clients_say'),
    Testimonial : testimonials    
  }
  return (
    <section className="relative w-full py-10 bg-white" id="testimonial-section">
      <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl  mx-auto">
          <div className="max-w-3xl w-full mx-auto text-center mb-5 xs:mb-10 xl:mb-20">
                <h2 className="capitalize text-slate-950 text-2xl xs:text-3xl !leading-tight lg:text-4xl xl:text-5xl  font-extrabold font-PlusJakartaSans" dangerouslySetInnerHTML={{__html:TestimonialData.title}}></h2>
          </div>
        
          <div className="justify-center block lg:flex items-center relative gap-5">              
                  {TestimonialData.Testimonial.map((item, index) => (
                    <div className="w-full lg:w-1/3 mb-5" key={item?.id || index}>
                      <TestimonialItem data={item} />
                    </div>
                  ))}
                  
              {/* </Swiper> */}
          </div>
        
      </div>
    </section>
  );
};

export default ClientTestimonials;